import Cookies from 'js-cookie'

export default {
  has(name) {
    return !!Cookies.get(name)
  },
  set(name, value) {
    Cookies.set(name, value)
  }
}